import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const getImageProduit = async id => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/produits/image/${id}`, {
      responseType: 'blob', // Ensures the response is treated as binary data
    });
    return URL.createObjectURL(response.data); // Create a URL for the image blob
  } catch (error) {
    console.error('Error fetching image:', error);
    throw error;
  }
};

export const addProduit = async data => {
  try {
    const formData = new FormData();

    // Append product data to the FormData object
    for (const key in data) {
      if (key !== 'avatar') {
        formData.append(key, data[key]);
      }
    }

    // Convert the Base64 image to a Blob and append it to FormData
    if (data.avatar && data.avatar[0].base64) {
      const base64Data = data.avatar[0].base64.split(',')[1]; // Remove the Base64 prefix
      const byteCharacters = atob(base64Data); // Decode Base64 to binary
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: data.avatar[0].type }); // Create a Blob with the correct MIME type

      formData.append('image', blob, data.avatar[0].path); // Append the Blob with a file name
    }

    // Send the POST request with FormData
    const res = await axiosInstance.post(baseUrl + '/produits/ajouter', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getProduits = async filterState => {
  console.log(filterState);
  try {
    const res = await axiosInstance.get('/produits/produits', {
      params: filterState,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getProduit = async idProduit => {
  try {
    const res = await axios.get(baseUrl + `/produits/produit/${idProduit}`);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getCategories = async () => {
  try {
    const res = await axios.get(baseUrl + '/produits/categories');
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getMarques = async () => {
  try {
    const res = await axios.get(baseUrl + '/produits/marques');
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const updateProduit = async (produits, attributs) => {
  try {
    console.log('produits', produits);
    console.log('attributs', attributs);
    const res = await axiosInstance.post(`/produits/updateAttributsProduit`, {
      produits: produits,
      attributs: attributs,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const fetchClassmentProduit = async () => {
  try {
    const res = await axiosInstance.get(`/produits/classementProduit`);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const updateConventionProduits = async (produits, remiseConvention) => {
  try {
    console.log('produits', produits);
    console.log('remiseConvention', remiseConvention);
    const res = await axiosInstance.post(`/produits/updateConventionProduits`, {
      produits: produits,
      remiseConvention: remiseConvention,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
